module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dxspB"))).then(() => parcelRequire('cvs7o'));